module.exports = __webpack_public_path__ + "img/pic5.8e6a8ab.webp";